import type { MutableRefObject } from 'react';
import type { UseFormGetFieldState, UseFormGetValues, UseFormReset } from 'react-hook-form';
import {
  areGuaranteesRootSectionFormValuesEqual,
  buildGuaranteesRootSectionHydrationValues,
  getDirtyGuaranteesRootSectionDraftFieldNames,
} from '../../rootSection/utils.ts';
import type { TGuaranteesRootSectionFormValues } from '../../rootSection/types.ts';

type THydrateGuaranteesApplicationFormParams = {
  currentApplicationId: string;
  defaultValues: TGuaranteesRootSectionFormValues;
  getFieldState: UseFormGetFieldState<TGuaranteesRootSectionFormValues>;
  getValues: UseFormGetValues<TGuaranteesRootSectionFormValues>;
  previousApplicationIdRef: MutableRefObject<string>;
  reset: UseFormReset<TGuaranteesRootSectionFormValues>;
  onApplicationChange: () => void;
};

export const hydrateGuaranteesApplicationForm = ({
  currentApplicationId,
  defaultValues,
  getFieldState,
  getValues,
  previousApplicationIdRef,
  reset,
  onApplicationChange,
}: THydrateGuaranteesApplicationFormParams) => {
  const currentValues = getValues();
  const isSameApplication = previousApplicationIdRef.current === currentApplicationId;
  const dirtyDraftFieldNames = isSameApplication
    ? getDirtyGuaranteesRootSectionDraftFieldNames(getFieldState)
    : [];
  const hydrationValues = buildGuaranteesRootSectionHydrationValues({
    currentValues,
    defaultValues,
    dirtyFieldNames: dirtyDraftFieldNames,
  });

  if (!isSameApplication) {
    onApplicationChange();
    previousApplicationIdRef.current = currentApplicationId;
  }

  if (areGuaranteesRootSectionFormValuesEqual(currentValues, hydrationValues)) {
    return;
  }

  if (dirtyDraftFieldNames.length) {
    reset(defaultValues, { keepDirtyValues: true });

    return;
  }

  reset(defaultValues);
};
